import { render, staticRenderFns } from "./customerArchives.vue?vue&type=template&id=0dc0f839&scoped=true&"
import script from "./customerArchives.vue?vue&type=script&lang=js&"
export * from "./customerArchives.vue?vue&type=script&lang=js&"
import style0 from "./customerArchives.vue?vue&type=style&index=0&id=0dc0f839&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc0f839",
  null
  
)

export default component.exports